module.exports = __webpack_public_path__ + "assets/img/detail-head-name-back.d6ea8c77.png";